import Base from '@studiometa/js-toolkit';
import Cookies from 'js-cookie';
import { isDev } from '../config';

/**
 * ProfilTopHeader class.
 *
 */
export default class ProfilTopHeader extends Base {
  /**
   * App configuration.
   * @return {Object}
   */
  get config() {
    return {
      name: 'ProfilTopHeader',
      log: isDev(),
      refs: ['btn', 'links[]'],
    };
  }

  isOpen = false;

  /**
   * Get Current User Profile
   *
   * @return {String} Current User Profile from Session Cookies
   */
  get currentProfile() {
    return Cookies.get('current_profile');
  }

  /**
   * Set Current User Profile
   *
   * @param {string} value New profile value
   */
  set currentProfile(value) {
    Cookies.set('current_profile', value);
  }

  /**
   * Toggle dropdown
   * @return {void}
   */
  onBtnClick() {
    if (this.isOpen) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  /**
   * Open Dropdown
   * @return {void}
   */
  openDropdown() {
    this.isOpen = true;
    this.$el.classList.add('open');
  }

  /**
   * Close Dropdown
   * @return {void}
   */
  closeDropdown() {
    this.isOpen = false;
    this.$el.classList.remove('open');
  }

  /**
   * Click on link
   * @param  {Object} e clicked element
   * @return {void}
   */
  onLinksClick(e) {
    this.currentProfile = e.currentTarget.dataset.slug;
  }
}
